<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="paymentModal" role="dialog" tabindex="-1" v-if="plaidAccounts">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="paymentModalLabel">Choose an Account</h4>
                                    <button @click="toAccounts()" aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                                </div>
                                <div class="modal-body card-blue">
                                    <div class="card-body">
                                        <div class="tab-content">
                                            <div class="tab-pane active" id="iprofile" role="tabpanel">
                                                <div class="row">
                                                    <div class="col-lg-6 col-md-6" v-bind:key="index" v-for="(account, index) in plaidAccounts">
                                                        <div @click="selectAccount(index, account)" class="card card-hover" style="cursor: pointer">
                                                            <div :class="{'bg-success text-white': selectionNum === index}" class="card-body">
                                                                <h4 class="card-title">Account #{{index+1}}</h4>
                                                                <h4 class="font-bold m-t-20 m-b-10">XXXXXXXXX......{{account.mask}}</h4>
                                                                <p class="m-t-0">{{account.official_name}}</p>
                                                                <strong>{{account.name}}</strong>
                                                                <br> {{account.type}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="linkAccount()" class="btn btn-success">Submit</button>
                                    <button @click="toAccounts()" class="btn waves-effect waves-light btn-danger" data-dismiss="modal"
                                            type="button">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ListAccounts",
        computed: {
            ...mapGetters(["currentOrg"])
        },
        props: ['public_token'],
        data() {
            return {
                plaidAccounts: [],
                selectionNum: -1,
                selectedAccount: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                if(this.public_token === undefined) {
                    this.$toastr('error', 'Token Expired! Please try again', 'Error');
                } else {
                    $("#paymentModal").modal('show');
                    await this.getPlaidAccounts();
                }
            },
            async getPlaidAccounts() {
                    try {
                        $(".preloader").fadeIn();
                        let reply          = await this.$http.get("/banking/plaid_accounts", {
                            params: {
                                public_token: this.public_token
                            }
                        });
                        $(".preloader").fadeOut();
                        this.plaidAccounts = reply.data.accounts;
                    } catch(e) {
                        console.log(e);
                    }
            },
            selectAccount(index, account) {
                this.selectionNum    = index;
                this.selectedAccount = account;
            },
            toAccounts() {
                $("#paymentModal").modal('show');
                this.$router.push({name: 'accounts'});
            },
            async linkAccount() {
                $("#paymentModal").modal('hide');
                try {
                    await this.$http.post(`/banking/${this.currentOrg.id}/linkaccount`, {
                        account: this.selectedAccount,
                        public_token: this.public_token
                    });
                    this.$toastr('success', 'Bank Account Successfully Linked', 'Success');
                    this.$router.push({name: 'accounts'});
                } catch(e) {
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>
</style>
